import { render } from "./TheBaoCaoGD.vue?vue&type=template&id=a699cb1e"
import script from "./TheBaoCaoGD.vue?vue&type=script&lang=js"
export * from "./TheBaoCaoGD.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__